import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import '../Challenge/IdeaSection/EditIdea.css';
import './EditPoll.css';

class EditPoll extends Component {

    render() {
        return (
            <EditPollForm {...this.props} />
        );
    }

}

const INITIAL_STATE = {
    error: null,
    wronTag: false,
    editionLoading: false,
    question: '',
    extraAnswerFields: [],
    nbAnswerFields: 0,
    extraNbFields: 0,
    answers: {},
};

class DocumentInput extends Component {
    render() {
        return (
            <input
                onChange={this.props.onChange}
                type="modal-poll"
                className="modal-poll-answer-field container placeholder-label"
                name={`answer${this.props.index}`}
                placeholder={`Réponse n°${this.props.index}`}
                value={this.props.value}
                maxLength="50" />)
    }
}

class EditPollFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...INITIAL_STATE,
            question: this.props.poll.question,
            answers: this.props.poll.answers,
            nbAnswerFields: Object.keys(this.props.poll.answers).length
        };
        this.add = this.add.bind(this);
    }

    add() {
        const extraAnswerFields = this.state.extraAnswerFields.concat(DocumentInput);
        this.setState({ extraAnswerFields, extraNbFields: this.state.extraNbFields + 1 });
    }

    onChange = event => {
        if (event.target.name === 'question') {
            this.setState({ [event.target.name]: event.target.value });
        }
        else {
            this.setState({
                answers: Object.assign({},
                    this.state.answers, { [event.target.name]: event.target.value })
            })
        }
    };

    onSubmit = async (event) => {
        this.setState({ editionLoading: true });
        event.preventDefault();
        const { pollId, capsuleId } = this.props
        const { question, answers } = this.state;
        this.props.poll.question = question
        this.props.poll.answers = answers

        await this.props.firebase.db.collection('capsules').doc(capsuleId).collection('polls').doc(pollId).update({
            question,
            answers
        })
        this.setState({ editionLoading: false })
        this.props.onClose();
    };

    render() {
        const { classes } = this.props
        const { question, answers, nbAnswerFields, error } = this.state
        let oldAnswerFields = []
        for (let i = 0; i < nbAnswerFields; i++) {
            oldAnswerFields.push(
                <DocumentInput onChange={this.onChange} key={i + 1} index={i + 1} value={this.state.answers[`answer${i + 1}`]} />
            )
        }
        const additionalAnswers = this.state.extraAnswerFields.map((Element, index) => {
            return <Element onChange={this.onChange} key={index + 1 + nbAnswerFields} index={index + 1 + nbAnswerFields} value={this.state.answers[`answer${index + 1 + nbAnswerFields}`]} /> //index + 3 because we already have 2 answers
        });
        return (
            <>

                <div className="create-poll-container">

                    <div className="modal-poll-header">
                        <img className="modal-poll-little-img" src={require('../../assets/polls/soucoupe_little.svg')} alt="Small" />
                        <div className="modal-poll-title">Editer le sondage</div>
                        <img className="modal-poll-big-img" src={require('../../assets/polls/soucoupe_big.svg')} alt="Big" />
                    </div>


                    <form onSubmit={this.onSubmit}>

                        <div className="modal-poll-form-container-mobile">

                            <div>
                                <div className="modal-poll-form-group">
                                    <label htmlFor="question" className="modal-poll-basic-text">Quelle est votre question ?</label>
                                    <input onChange={this.onChange} value={question} type="modal-poll" className="modal-poll-question-field container placeholder-label" name="question" placeholder="Ecrivez votre question" />

                                    <label htmlFor="answer" className="modal-poll-basic-text">Réponses</label>
                                    {oldAnswerFields}
                                    {additionalAnswers}

                                    <div className="modal-poll-footer">
                                        <button type="button" onClick={this.add} className="modal-poll-button-add">+ Ajouter une réponse</button>
                                        <button onClick={this.onSubmit} className="modal-poll-button" disabled={answers.answer1.length === 0 || answers.answer2.length === 0}>OK</button>
                                    </div>


                                </div>
                            </div>

                            {error && <p>{error.message}</p>}
                        </div>

                    </form>
                </div>
            </>
        );
    }
}

EditPollFormBase.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles_loader = theme => ({
    root: {
    },
    buttonProgress: {
        color: '#0070A2',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -8,
        marginLeft: -15,
    },
});

const EditPollForm = withRouter(withFirebase(withStyles(styles_loader)(EditPollFormBase)));

export default EditPoll;
export { EditPollForm };